<kendo-dialog-titlebar (close)="cancel()">
  <div class="ss-dialog-title">
    {{ title | translate }}
  </div>
</kendo-dialog-titlebar>
<!-- CONTENT -->
<div class="ss-dialog-content">
  <div class="ss-pop-confirm-message" id="message"></div>
</div>
<!-- BUTTONS -->
<kendo-dialog-actions>
  <button
    kendoButton
    themeColor="primary"
    [svgIcon]="allIcons.xIcon"
    fillMode="flat"
    (click)="cancel()"
  >
    {{ button_no | translate }}
  </button>
  <button kendoButton themeColor="primary" [svgIcon]="allIcons.checkIcon" (click)="confirm()">
    {{ button_yes | translate }}
  </button>
</kendo-dialog-actions>
